import { oz } from '@weft/utils';
import { FIXED_PRODUCT_TYPES } from '../../fixed-product-type-schema';
import { ServiceProductConfigurationSchema } from './service-product-configuration';

export const ServiceProductSettingsSchema = oz.object({
  productType: oz.literal(FIXED_PRODUCT_TYPES.Service),
  productConfiguration: ServiceProductConfigurationSchema,
}).openapi('ServiceProductSettings');

export type ServiceProductSettings = oz.infer<typeof ServiceProductSettingsSchema>;